import { autoinject } from 'aurelia-framework';
import { MooringSalesOrderType } from 'models/mooring';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class MooringSalesOrderTypeService extends BaseApiService<MooringSalesOrderType> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, MooringSalesOrderType);
  }
}
